var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._g(_vm._b({tag:"component"},'component',_vm.providedProps,false),_vm.$listeners),[_vm._l((_vm.$slots),function(index,name){return _vm._t(name,null,{"slot":name})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }